module.exports = __webpack_public_path__ + "static/img/美的纯平全嵌洗烘套装.39e0bc0c.png";